import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Membership } from './components/membership/Membership';
import { StructuredData } from './components/StructuredData';
import { WhyChooseUs } from './components/WhyChooseUs';
import { HowItWorks } from './components/HowItWorks';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { ServiceArea } from './components/ServiceArea';
import { FAQ } from './components/FAQ';
import { BookingForm } from './components/BookingForm';
import { InstagramFeed } from './components/InstagramFeed';
import { FloatingActions } from './components/FloatingActions';
import { Footer } from './components/Footer';
interface AppProps {
  /** Language the site loads in. Visitors can still toggle EN/ES. */
  language?: 'en' | 'es';
  /** Show the Instagram feed section above the footer. */
  showInstagramFeed?: boolean;
}
export function App({
  language = 'en',
  showInstagramFeed = true
}: AppProps) {
  return <LanguageProvider initialLang={language} data-id="element-0" data-mp="3recdlirailf5">
      <div className="min-h-screen w-full bg-white" data-id="element-1" data-mp="67yvnd9206b">
        <StructuredData data-id="element-2" data-mp="82ovg3doih9" />
        <header className="sticky top-0 z-50 w-full" data-id="element-3" data-mp="2zld2jatxbhc2">
          <AnnouncementBar data-id="element-4" data-mp="2zmwi0z7r9ocs" />
          <Navbar data-id="element-5" data-mp="33mou3lwcycmw" />
        </header>

        <main data-id="element-6" data-mp="33lx18iu5at0b">
          <Hero data-id="element-7" data-mp="33ngfk3w8qtzg" />
          <Services data-id="element-8" data-mp="33mykvbp88ntn" />
          <Membership data-id="element-9" data-mp="33ohzyyz5cstu" />
          <Gallery data-id="element-10" data-mp="38l8j5v6904jh" />
          <WhyChooseUs data-id="element-11" data-mp="38kqbm2e4y3w9" />
          <HowItWorks data-id="element-12" data-mp="38kgkucl9nspi" />
          <Testimonials data-id="element-13" data-mp="38o4fjf2g6l5t" />
          <About data-id="element-14" data-mp="3dle28mygcipy" />
          <ServiceArea data-id="element-15" data-mp="3dlw5w4ng1z7w" />
          <FAQ data-id="element-16" data-mp="3dmfmni1cyhkc" />
          <BookingForm data-id="element-17" data-mp="3dirvgpjdy78s" />
          {showInstagramFeed && <InstagramFeed data-id="element-18" data-mp="nwc0jp6vnpuo" />}
        </main>

        <Footer data-id="element-19" data-mp="nvan5e2e2r9s" />
        <FloatingActions data-id="element-20" data-mp="nxx0jubyo0zx" />
      </div>
    </LanguageProvider>;
}